import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllTasksPage } from "src/components/views/tasks/pages/AllTasksPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/tasks/allTasks")({
	staticData: { title: i18n.t("all_tasks"), legacyViewKey: "allTasksPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllTasksPage />;
}
